const EMPTY_MARKERS = new Set(["", "-", "s/n", "sn", "sin serie", "sin nro", "sin numero"]);

export function normalizeInstrumentText(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ");
}

function compact(value) {
  return normalizeInstrumentText(value).replace(/[\s._-]+/g, "");
}

function isMeaningful(value) {
  const normalized = normalizeInstrumentText(value);
  return !EMPTY_MARKERS.has(normalized);
}

function scoreDuplicate(candidate, input) {
  const serialMatch =
    isMeaningful(input.serial) && compact(candidate.serial) === compact(input.serial);
  if (!serialMatch) return 0;

  let score = 4;
  if (isMeaningful(input.brand) && compact(candidate.brand) === compact(input.brand)) {
    score += 2;
  }
  if (isMeaningful(input.model) && compact(candidate.model) === compact(input.model)) {
    score += 2;
  }
  if (isMeaningful(input.tag) && compact(candidate.tag) === compact(input.tag)) {
    score += 1;
  }

  return score;
}

export async function findInstrumentDuplicates(supabase, input) {
  if (!input?.client_id || !isMeaningful(input?.serial)) return [];

  const { data, error } = await supabase
    .from("instruments")
    .select(
      "id, lab_id, tag, serial, brand, model, type, status, created_at, observations, reception_date, departure_date, calibration_place"
    )
    .eq("client_id", input.client_id)
    .order("lab_id", { ascending: true })
    .limit(2000);

  if (error) throw error;

  return (data || [])
    .filter((row) => row.id !== input.exclude_id)
    .map((row) => ({ ...row, duplicate_score: scoreDuplicate(row, input) }))
    .filter((row) => row.duplicate_score >= 6)
    .sort((a, b) => {
      if (b.duplicate_score !== a.duplicate_score) {
        return b.duplicate_score - a.duplicate_score;
      }
      return Number(a.lab_id || 0) - Number(b.lab_id || 0);
    });
}

export function buildDuplicateInstrumentMessage(duplicates, input) {
  const first = duplicates?.[0];
  if (!first) return "";

  const label = [
    first.lab_id ? `Lab ID ${first.lab_id}` : null,
    first.tag ? `Tag ${first.tag}` : null,
    first.serial ? `Serie ${first.serial}` : null,
    [first.brand, first.model].filter(Boolean).join(" "),
  ]
    .filter(Boolean)
    .join(" - ");

  const requested = [
    input?.tag ? `Tag ${input.tag}` : null,
    input?.serial ? `Serie ${input.serial}` : null,
    [input?.brand, input?.model].filter(Boolean).join(" "),
  ]
    .filter(Boolean)
    .join(" - ");

  const extra =
    duplicates.length > 1
      ? `\n\nTambien hay ${duplicates.length - 1} coincidencia(s) mas para revisar.`
      : "";

  return [
    "Ya existe un instrumento muy parecido para este cliente.",
    "",
    `Existente: ${label}`,
    requested ? `Intentabas cargar: ${requested}` : null,
    "",
    "Para evitar duplicar el ID/QR, se va a usar el instrumento existente.",
    "Si realmente es otro equipo fisico, primero revisalo desde Buscar instrumentos.",
    extra,
  ]
    .filter(Boolean)
    .join("\n");
}
